jQuery.noConflict();
(function($) {
  $(function(){
    var slide = $('.menu-item a');
    slide.next("ul").hide();

    slide.click(function(){
      var t = this;
      slide.each(function(){
        if( t === this ) $(this).next("ul").slideToggle("fast");
        else $(this).next("ul").slideUp();
      });
    });
  });
})(jQuery);